export const copyToClipboard = (url) => {
    const listener = (e) => {
        e.clipboardData?.setData('text/plain', url);
        e.preventDefault();
        document.removeEventListener('copy', listener);
    };
    document.addEventListener('copy', listener);
    document.execCommand('copy');
};